/** @internal */
export const Layout = Object.freeze({
  marginX: 'mx-16'
});
